import { HeaderActions, PageHeader } from "components/Reports/components";
import "assets/styles/reports/balanceSheet.scss";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { apiGetFactor } from "api/factorApi";
import { Form, Formik } from "formik";
import { setFactorPattern } from "store/actions/factorAction";
import { Container, styled } from "@mui/material";
import FactorSettingInfo from "./infoSetting/FactorSettingInfo";
import FactorPattern from "./FactorPattern";
import FactorSettingPattern from "./patternSetting/FactorSettingPattern";
import { invoiceInitialValues } from "store/reducers/factorReducer";
import { apiGetAppSettings, apiSetAlert, apiSetAppSettings } from "api/appApi";
import { appSetSettings } from "store/actions/appAction";
import { useAppDispatch, useAppSelector } from "store/store";
import FactorPatternTemplate from "./FactorPatternTemplate";

const tab = {
    title: "",
    description: "",
};

const ItemContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: "36px",
}));

const BalanceSheetContainer = styled("div")(({ theme }) => ({
    width: "100%",
    height: "auto",
    display: "grid",
    gridTemplateColumns: "63% 32%",
    [theme.breakpoints.down("md")]: {
        display: "block",
        // gridTemplateColumns: "100% 100%",
    },
    [theme.breakpoints.down("md")]: {
        display: "block",
        // gridTemplateColumns: "100% 100%",
    },
    [theme.breakpoints.down("sm")]: {
        display: "block",
        // gridTemplateColumns: "100% 100%",
    },
    justifyContent: "space-between",
    marginBottom: "100px",
}));

type factorSettingType = "chooseInfo" | "choosePattern";
export type factorTemplate = "template1" | "template2"
export default function FactorViewComponent({
    factorId,
    factorType,
    autoPrint,
}: {
    factorId: string | number;
    factorType: string;
    autoPrint?: boolean;
}) {
    const dispatch = useAppDispatch();
    const store = useAppSelector((state: any) => state);
    const business = store.businessReducer?.business;
    const { token } = business;
    const { businessAvatar } = business?.business;
    const { factor } = store.factorReducer;
    const { appSettings } = store.appReducer;

    const [factorIsFetched, setFactorIsFetched] = useState(false);
    const [settingData, setSettingData] = useState(appSettings);
    const [template, setChoseTemplate] = useState<factorTemplate>("template2");

    const callBack = () => {
        return setFactorIsFetched(true);
    };

    const [factorSettingComponent, setFactorSettingComponent] = useState<factorSettingType>("chooseInfo");
    tab.title = `چاپ فاکتور ${factor?.accountingCode}#`;

    const printRef = useRef<any>(null);
    const invoiceRef = useRef(null);

    useEffect(() => {
        dispatch(apiGetFactor(factorId, factorType, token, callBack));
        if (true) {
            apiGetAppSettings({ token }).then((response) => {
                const settings = response?.data.settings;
                setSettingData(settings);

                dispatch(appSetSettings(settings));
                if (settings?.printSettings) {
                    dispatch(setFactorPattern(JSON.parse(settings?.printSettings)));
                }
            });
        }
    }, [token]);

    // useEffect(() => {
    //   dispatch(
    //     apiGetItemNote(token, factorId, "factor", (res: any[]) => {
    //       res?.length && setState((x: any) => ({ ...x, description: res[0].text }));
    //     })
    //   );
    // }, [factorId]);

    const [pattern, setPattern] = useState(2);

    const onSubmit = (values: typeof invoiceInitialValues) => {
        const stringedVal = JSON.stringify(values);
        apiSetAppSettings({ token, settings: { ...settingData, printSettings: stringedVal } });
        dispatch(setFactorPattern(values));

        dispatch(apiSetAlert("اطلاعات با موفقیت ذخیره سازی شد.", "success"));
    };

    useEffect(() => {
        if (factorIsFetched && autoPrint) printRef.current.handleClick();
    }, [factorIsFetched]);

    const { factorPattern: initialValues } = useSelector((state: any) => state).factorReducer;

    function PrintContent() {
        if (!factorIsFetched) return <></>;
        if (template === "template1")
            return (
                <div id="factor">
                    <FactorPattern pattern={pattern} ref={invoiceRef} data={factor} />
                </div>
            );
        else
            return <FactorPatternTemplate 
             ref={invoiceRef}
             data={factor} />
    }

    let init = { ...initialValues };
    if (factor?.description) init.description = factor?.description;
    if (!init?.logo && businessAvatar) init.logo = businessAvatar;

    return (
        <Container maxWidth="lg">
            <div className="warp-table">
                <div className="header-table mb-4">
                    <PageHeader tab={tab} />
                    <HeaderActions backComment="بازگشت به لیست فاکتور ها" backLink="/factors" />
                </div>
                <Formik initialValues={init} enableReinitialize onSubmit={onSubmit} style={{ height: "auto" }}>
                    {() => (
                        <Form style={{ height: "auto" }}>
                            <BalanceSheetContainer>
                                <ItemContainer>
                                    <PrintContent />
                                </ItemContainer>

                                <ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
                                    {factorSettingComponent === "chooseInfo" && (
                                        <FactorSettingInfo
                                            factor={factor}
                                            ref={printRef}
                                            setFactorSetting={setFactorSettingComponent}
                                            setPattern={setPattern}
                                            invoiceRef={invoiceRef}
                                            setChoseTemplate={setChoseTemplate}
                                        />
                                    )}
                                    {factorSettingComponent === "choosePattern" && (
                                        <FactorSettingPattern
                                            setFactorSetting={setFactorSettingComponent}
                                            setPattern={setPattern}
                                            invoiceRef={invoiceRef}
                                        />
                                    )}
                                </ItemContainer>
                            </BalanceSheetContainer>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
}
